module.exports = __webpack_public_path__ + "img/kermel.98391198.png";